export enum Language {
  RU = 'ru',
  EN = 'en'
}

export interface State {
  language: Language;
}
